export default __webpack_public_path__ + "static/media/DisputeValidations.453f67ea.svg";